import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../../constants/styles';

const { FLAT_BUTTON_BG_COLOR, FLAT_BUTTON_COLOR } = constants;

let styles = {
  form: {
    height: '100%',
    width: 500,
    maxWidth: '100%',
    overflow: 'auto'
  },
  flatButton: {
    backgroundColor: FLAT_BUTTON_BG_COLOR,
    color: FLAT_BUTTON_COLOR,
    ':hover': {
      backgroundColor: 'none'
    }
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/forms/addactionform/AddActionForm.styles.js